export class SEOCheckHelper {
    constructor(parent, config) {
        this.parent = parent;
        this.config = config;
    }

    checkLength(string, check) {
        const l = string.length
        return this.checkRanges(l, check)
    }

    checkRanges(value, check) {
        const checkConfig = this.config.checks[check]
        for (const r of checkConfig.ranges) {
            if (this.within(value, r.range)) {
                if(r.resultTemplate){
                    const idealRange = checkConfig.ranges.find(range => range.key === 'ideal')
                    if(idealRange){
                        const resultInfo = this.handleResultInfo({current:value,upper:idealRange.range[1],lower:idealRange.range[0]}, this.getTranslation('general',r.resultTemplate))
                        return { score: checkConfig.score, multiplier: r.multiplier, key: r.key, check: check, category: checkConfig.category, resultInfo:resultInfo }
                    }else{
                        return { score: checkConfig.score, multiplier: r.multiplier, key: r.key, check: check, category: checkConfig.category }
                    }
                }else{
                    return { score: checkConfig.score, multiplier: r.multiplier, key: r.key, check: check, category: checkConfig.category }
                }

            }
        }
        return { score: 0, key: 'outside_of_range', check: check, category: checkConfig.category }
    }

    async checkMetaDescription(self) {
        const desc = document.querySelector('meta[name="description"]') ? document.querySelector('meta[name="description"]').content : ''
        return self.checkLength(desc, 'checkMetaDescription')
    }

    async checkTitle(self) {
        return self.checkLength(document.title, 'checkTitle')
    }

    async checkImageAlt(self) {
        const images = self.parent.getElementsByTagName('img')
        let errors = 0
        for (let image of images) {
            if (!image.alt && !image.getAttribute('data-alt')) {
                if (self.config.checks.checkImageAlt.highlight) {
                    image.classList.add('seo-check-highlight-' + self.config.checks.checkImageAlt.highlight)
                }
                errors++
            }
        }
        return self.checkRanges(errors, 'checkImageAlt')
    }

    async checkImageTitle(self) {
        const images = self.parent.querySelectorAll('img')
        let errors = 0
        for (let image of images) {
            if (!image.title) {
                errors++
            }
        }
        return self.checkRanges(errors, 'checkImageTitle')
    }

    async checkSentenceLength(self) {
        textElements = self.parent.querySelectorAll('p')
        for (const el of textElements) {
            const text = node.innerText || node.textContent;
            const sentences = text.trim().split('.').filter(a => a.trim().length > 0);
            for (const s of sentences) {
                const words = sentence.split(' ').filter(a => a.trim().length > 0);

            }
        }
    }

    async checkParagraphLength(self) {
        textElements = self.parent.querySelectorAll('p')
        for (const el of textElements) {

        }
    }

    async checkCanonical(self) {
        const el = document.head.querySelector('link[rel="canonical"]')
        const res = el.href ? 1 : 0
        return self.checkRanges(res, 'checkCanonical')
    }

    async checkRobotsIndex(self) {
        const el = document.querySelector('meta[name="robots"]')
        const res = ! el.content.includes('noindex') && el.content.includes('index') ? 1 : 0
        return self.checkRanges(res, 'checkRobotsIndex')
    }

    async checkRobotsFollow(self) {
        const el = document.head.querySelector('meta[name="robots"]')
        const res = !el.content.includes('nofollow') && el.content.includes('follow') ? 1 : 0
        return self.checkRanges(res, 'checkRobotsFollow')
    }

    async checkLinks(self) {
        const scope = document.querySelector('seo-check').parentElement
        const l = scope.querySelectorAll('a').length
        return self.checkRanges(l, 'checkLinks')
    }

    /**
     * Checks if a value is within a positive range. If a bound is null, it is treated as 0 / positive infinity
     * @param {Number} x
     * @param {Array<Number>} range
     * @returns
     */
    within(x, range) {
        let start = range[0] || 0
        if(start == null){
            start = 0
        }
        let end = range[1]
        if(end == null){
            end = Infinity
        }
        return x >= start && x <= end;
    }

    countWords(node) {
        const text = node.innerText || node.textContent;
        return text.trim().split(/\s+/g).filter(a => a.trim().length > 0).length;
    }

    getColorFromGradient(v, colorGradient) {

        if (v == 1) v = 0.999;
        let l = colorGradient.length;
        let pos = v * (l - 1);
        let box = Math.min(l - 1, Math.floor(pos));
        let d = pos % 1;
        let from = colorGradient[box]
        let to = colorGradient[box + 1]
        let r = Math.min(255, Math.floor((from[0] + (to[0] - from[0]) * d) * 256))
        let g = Math.min(255, Math.floor((from[1] + (to[1] - from[1]) * d) * 256))
        let b = Math.min(255, Math.floor((from[2] + (to[2] - from[2]) * d) * 256))
        return 'rgb(' + r + ',' + g + ',' + b + ')'
    }

    handleResultInfo(resultObject,template){

        if(template){
            return template
                .replace('$upper',resultObject['upper'])
                .replace('$lower',resultObject['lower'])
                .replace('$current',resultObject['current']);
        }
    }

    getTranslation(category, key, fallback) {
        const userLang = (navigator.language || navigator.userLanguage).startsWith('de') ? 'de' : 'en'
        if (userLang == 'de') {
            if (this.config.languageKeys.de[category][key]) {
                return this.config.languageKeys.de[category][key]
            } else {
                if (fallback) {
                    return this.config.languageKeys.de.general['missing_key'] + key
                } else {
                    return ''
                }
            }
        } else {
            if (this.config.languageKeys.en[category][key]) {
                return this.config.languageKeys.en[category][key]
            } else {
                if (fallback) {
                    return this.config.languageKeys.en.general['missing_key'] + key
                } else {
                    return ''
                }
            }
        }

    }
}
